import React from 'react'

import EditableInput from "./input-component"
import FieldProto from "../../../../proto/field-proto";
import {toggleClass} from "../../../../../gd/utils/dom-and-react/react-utils"

type Props = {
    field               : FieldProto
    value               : any // string or number

    className?          : string
    inputClassName?     : string
    viewClasses?        : string
    editClasses?        : string

    disabled?           : boolean
    isNumber?           : boolean   // set to true if this is a number / currency

    onChange?           : callback
    onImmediateChange?  : callback

    // Experimental Vic
    onEnter?            : callback
    options?            : any
    // autoSaveChanges?    : boolean   // I think this no use
    // end experimental
}


export default class FieldString_RenderEditableInlineInput extends React.Component<Props,any> {

    public value        : any
    public renderState  : any
    public input        : any
    public _switchToViewOnNextChange    : boolean   = false

    static defaultProps = {
        viewClasses     : "ui5-txt-default ui5-field-input-hover-border w-300 h-36 p-l-10 p-r-10",
        editClasses     : "ui5-txt-default ui5-field-form-editable w-300 h-36 p-l-10 p-r-10",
        isNumber        : false,
        disabled        : false
    }

    constructor(props:any) {
        super(props);

        this.value          = this.props.value

        this.renderState    = 'view'

        if (this.props.options?.autofocus) {
            this.renderState = 'edit'
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps:any, nextContext:any) {
        if (this.value !== nextProps.value) {
            this.value = nextProps.value;
        }
    }

    isValueValid(value?:string) {
        return this.props.field.isValueValid(value || this.value)
    }

    onClick = (e?:React.SyntheticEvent) => {
        if(e) e.stopPropagation();

        if (this.props.disabled) return

        this.renderState = 'edit';
        this.forceUpdate(()=>this.input.focus())
    }

    onBlur = () => {
        this._switchToViewOnNextChange = true;
    }

    onImmediateChange = (value:any) => {
        this.props.onImmediateChange && this.props.onImmediateChange(value)

        toggleClass(this.input, 'invalid-value', !this.isValueValid(value))
    }

    // bind is used for overwrite to work !!!
    onChange(value:any) { // dont change
        this.value = value;
        this.renderState = this._switchToViewOnNextChange ? 'view' : 'edit';

        this.forceUpdate(()=>{
            if (this.props.onChange) this.props.onChange(value)
        })
    }

    renderEditMode() {

        const classes = Classes(this.props.editClasses, this.props.className, {
            'ui5-txt-no-accent-default' : !this.value,
            'invalid-value'             : !this.isValueValid()
        })

        const ButtonComponent : any = _.get(this.props.field.components, 'ButtonComponent', false)

        // Patch for number / currency - tricky as it is in the string...
        let value = this.value
        if (this.props.isNumber) {
            if  (this.value === 0 || this.value==='0') {
                value = ''
            }
        }
        //

        return (
            <EditableInput ref                  = {(r:any)=>this.input = r}
                           className            = {classes}
                           inputClassName       = {this.props.inputClassName || "ui5-txt-default"}
                           value                = {value}
                           trimValue            = {_.isNil(this.props.field.trimValue)?true:this.props.field.trimValue}
                           icon                 = {
                               <React.Fragment>
                                   {_.get(this.props.field.components, 'ValueIcon', false)}
                                   {_.get(this.props.field.components, 'ValuePrefix', false)}
                               </React.Fragment>
                           }
                           button               = {
                               <React.Fragment>
                                   {ButtonComponent && <ButtonComponent field={this.props.field} value={this.value}/>}
                               </React.Fragment>
                           }
                           placeholder          = {this.props.field.placeholder}
                           onBlur               = {this.onBlur}
                           onChange             = {this.onChange.bind(this)}
                           onEnter              = {this.props.onEnter}  // experimenta
                            // autoSaveChanges={this.props.autoSaveChanges} // experimental
                            focusOnMount={this.props.options?.autofocus}

                           onImmediateChange    = {this.onImmediateChange}/>
        )
    }

    renderViewMode() {
        let displayValue = this.props.field.getDisplayValue(this.value);
        const classes = Classes(this.props.viewClasses, this.props.className, {
            'ui5-txt-no-accent-default': !displayValue,
            'invalid-value': !this.isValueValid()
        })

        const viewValueClasses = Classes('view-value', this.props.inputClassName)

        if (!displayValue && this.props.field.placeholder) displayValue = this.props.field.placeholder

        const ButtonComponent : any = _.get(this.props.field.components, 'ButtonComponent', false)

        return (
            <div className={classes} onClick={this.onClick}>
                {_.get(this.props.field.components, 'ValueIcon', false)}
                {_.get(this.props.field.components, 'ValuePrefix', false)}
                <div className={viewValueClasses}>{displayValue}</div>
                {ButtonComponent && <ButtonComponent field={this.props.field} value={displayValue}/>}
            </div>
        )
    }

    render() {
        switch (this.renderState) {
            case 'edit':
                return this.renderEditMode()

            case 'view':
            default:
                return this.renderViewMode()
        }
    }
}
